<div class="modal entity-edit-modal">
  <i class="fal fa-times modal__close"
     (click)="close()"></i>
  <h2>Quick Edit</h2>
  <ng-container *ngIf="entity">
    <app-entity-name-table [entityId]="entity.id"
                           [campaignId]="entity.campaignContextId"
                           class="entity-core-info-table--basic"></app-entity-name-table>

    <app-entity-language-table *ngIf="entity.entityType.languageEnabled"
                               [entityId]="entity.id"
                               [campaignId]="entity.campaignContextId"
                               class="entity-core-info-table--basic"></app-entity-language-table>

    <app-entity-dob-table *ngIf="entity.entityType.dateOfBirthEnabled"
                          [entityId]="entity.id"
                          [campaignId]="entity.campaignContextId"
                          class="entity-core-info-table--basic"></app-entity-dob-table>

    <app-entity-emails-table *ngIf="entity.entityType.emailEnabled"
                             [entityId]="entity.id"
                             [campaignId]="entity.campaignContextId"></app-entity-emails-table>

    <app-entity-phones-table *ngIf="entity.entityType.phoneNumberEnabled"
                             [entityId]="entity.id"
                             [campaignId]="entity.campaignContextId"></app-entity-phones-table>

    <app-entity-addresses-table *ngIf="entity.entityType.addressEnabled"
                                [entityId]="entity.id"
                                [campaignId]="entity.campaignContextId"></app-entity-addresses-table>

    <app-entity-social-table *ngIf="entity.entityType.socialsEnabled"
                             [entityId]="entity.id"
                             [campaignId]="entity.campaignContextId"></app-entity-social-table>

    <app-entity-ids *ngIf="showCustomIds"
                    [entityId]="entity.id"
                    [campaignId]="entity.campaignContextId"></app-entity-ids>

  </ng-container>
</div>
